import {
  Box,
  Button,
  Checkbox,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SolrufTextField from "../../components/SolrufTextField/SolrufTextField";
import SendIcon from "@mui/icons-material/Send";
// import PrimaryButton from '../Custom/PrimaryButton/PrimaryButton';
// import SolrufModal3 from '../Custom/SolrufModal/SolrufModal3';
// import sunSvg from '../../assets/sun.svg';
import siSvg from "../../assets/solar-installation.svg";
import smSvg from "../../assets/solar-maintenance.svg";
import spSvg from "../../assets/solar-products.svg";
import otherSvg from "../../assets/other.svg";
import { motion } from "framer-motion";
import { Controller, useForm } from "react-hook-form";
import Lottie from "lottie-react";
import sent from "../../assets/lottie/sent.json";
import solarHouse from "../../assets/lottie/solar-house.json";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { HashLink } from "react-router-hash-link";
import { toast } from "react-toastify";
import PrimaryButton from "../../components/Custom/PrimaryButton/PrimaryButton";
import {
  EnquiryMSItem,
  Background,
  FormWrapper,
  LeadFormWrapper,
  RowWrapper,
  SendWrapper,
  ThanksWrapper,
  Wrapper,
} from "../../components/HomeLeadForm/HomeLeadForm.style";
import { FormFeaturesWrapper } from "../home/home.style";
import OfferForm from "../OfferForm/OfferForm";
import Features from "../../components/Features/Features";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { withStyles } from "@mui/styles";
import { sendWhatsappNotification } from "../../utils/sendWhatsappNotification";
import saveFormDataToGoogleSheet from "../../utils/saveFormDataToSheet";
import { getTimeStamp } from "../../utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import TagManager from "react-gtm-module";
import { axiosInstance } from "../../utils/axiosInstance";

const StyledCheckbox = withStyles({
  root: {
    "& .MuiSvgIcon-root": {
      borderRadius: "50%",
    },
  },
})((props) => (
  <Checkbox
    disableRipple
    icon={<RadioButtonUncheckedIcon />}
    checkedIcon={<RadioButtonCheckedIcon />}
    {...props}
  />
));

// import { ActionsWrapper } from "../CustomerDetailsDrawer/GetAQuoteStyle";

const SolarLeadForm2 = ({ ...rest }) => {
  const navigate = useNavigate();

  //
  const [pageIdx, setPageIdx] = useState(1);
  // const [siOn, setSiOn] = useState(false);
  // const [smOn, setSmOn] = useState(false);
  // const [spOn, setSpOn] = useState(false);

  const [service, setService] = useState("n/a");

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [whatsappChecked, setWhatsappChecked] = useState(false);

  const handleWhatsappChecked = (event) => {
    setWhatsappChecked(event.target.checked);
  };

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    pinCode: "",
    city: "",
    state: "",
    address: "",
    predicted_system_capacity_kw: "",
    light_bill_in_unit: "",
    unit_cost: "",
    monthly_units_after_solar: "",
    project_type: "",
    mounting_type: "",
    remarks: "",
    services: [],
  });

  const [errors2, setErrors2] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.phoneNumber)
      newErrors.phoneNumber = "Phone number is required";
    else if (!/^\d{10}$/.test(formData.phoneNumber))
      newErrors.phoneNumber = "Phone number must be 10 digits";

    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email))
      newErrors.email = "Invalid email format";

    if (!formData.pinCode) newErrors.pinCode = "Pin Code is required";
    else if (!/^\d{6}$/.test(formData.pinCode))
      newErrors.pinCode = "Pin Code must be 6 digits";

    if (!formData.city) newErrors.city = "City is required";
    if (!formData.state) newErrors.state = "State is required";

    if (!formData.predicted_system_capacity_kw)
      newErrors.predicted_system_capacity_kw = "System Size (kW) is required";

    if (!formData.unit_cost)
      newErrors.unit_cost = "Electricity Tariff is required";

    if (!formData.monthly_units_after_solar)
      newErrors.monthly_units_after_solar =
        "Monthly Units After Solar is required";

    if (!formData.project_type)
      newErrors.project_type = "Project Type is required";

    if (!formData.mounting_type)
      newErrors.mounting_type = "Mounting Type is required";

    setErrors2(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
            ? [...prev.services, value]
            : prev.services.filter((service) => service !== value)
          : value,
    }));

    if (errors2[name]) {
      setErrors2((prevErrors) => ({ ...prevErrors, [name]: null }));
    }
  };

  const handleForm = async () => {
    if (!validateForm()) return;

    try {
      const response = await axiosInstance.post(
        "api/customer-form",
        formData, // axios automatically stringifies the data
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Form submitted:", response.data);
      // Additional API call using form response data
      const { predicted_system_capacity_kw, project_type } = formData;
      const itemsResponse = await axiosInstance.get(
        `api/get-items/${predicted_system_capacity_kw}/${project_type}`
      );
      console.log("Items response:", itemsResponse.data);
      // Assuming itemsResponse.data is an array of item objects
      const itemsData = itemsResponse.data[0];

      // Transform the itemsData array to the new format
      const formattedItems = itemsData.map((item) => ({
        properties: {
          particular_name: item.name || "", // Using the 'name' from the original item
          unit_price: 0, // Default value for unit price
          units: item.quantity || "1", // Using quantity or defaulting to "1"
          unit_type: item.unit || "Nos", // Using unit or defaulting to "Nos"
          hsn_sac_code: "", // Default or empty for now, adjust as needed
          igst: 0, // Default value for IGST
          cgst: 0, // Default value for CGST
          sgst: 0, // Default value for SGST
        },
      }));

      const payload = {
        light_bill_in_unit: formData.light_bill_in_unit,
        project_name: formData.name,
        mobile: formData.phoneNumber,
        email: formData.email,
        project_type: formData.project_type,
        mounting_type: formData.mounting_type,
        pincode: formData.pinCode,
        city: formData.city,
        state: formData.state,
        predicted_system_capacity_kw: formData.predicted_system_capacity_kw,
        unit_cost: formData.unit_cost,
        monthly_units_after_solar: formData.monthly_units_after_solar,
        rate_per_watt: "60",
        installed_systems: "0",
        projects: [],
        description:
          "Solruf is a Solar Marketplace & Installation platform where we connect you with Multiple Solar EPCs in your locality and provide you with Technical project management, EMI Financing & Solar installation support. India is leading the way to a greener revolution with Solar Energy. We aim to Fast Track growth to a greener future by providing access to clean energy products and services with focus on price and convenience.",
        particulars: formattedItems,
        has_umulative_tax: true,
        has_no_price_breakdown: true,
        cumulative_tax: "13.8",
        total_price: "0.00",
        terms_and_conditions:
          '<h1 dir="ltr"><strong>Terms and Conditions</strong></h1>\n<p><strong>&nbsp;</strong></p>\n<p dir="ltr">Estimation of representation</p>\n<p dir="ltr">This is a customised proposal with a cost estimate. It is not intended to be interpreted as a guarantee of the real system, energy production, or savings.&nbsp;</p>\n<p dir="ltr">The actual energy production and savings of the system will vary depending on its size, design, configuration, utility, rebates, and energy consumption.Also,any change in the design by customer after approving final design will may cost extra or cancellation of order.</p>\n<p><strong>&nbsp;</strong></p>\n<p dir="ltr">System cost</p>\n<p dir="ltr">This proposal\'s prices and costs are an estimate. Manufacturing, designing, sourcing, testing, supplying,installation, and commissioning are all part of the process. However, any changes to the quotation or additional services will incur a fee. The rates do not include maintenance fees. Please keep in mind that meter consolidation, load expansion will be in customers scope of work, and interior AC cabling will all be at actuals</p>\n<p dir="ltr">Validity of this proposal for a period of 15 days from submission of the proposal.</p>\n<p><strong>&nbsp;</strong></p>\n<h2 dir="ltr"><strong>Payment Terms</strong></h2>\n<p dir="ltr">1.An advance payment of 15% of the total contract value to be paid along with the project work order.</p>\n<p dir="ltr">2. Next payment of 60% of the total contract value to be paid against a proforma invoice before delivery of the system components.</p>\n<p dir="ltr">3. Next payment of 20% of the contact value to be paid after installation of the system..</p>\n<p dir="ltr">4. Balance 5% to be paid post installation of net meter and generation meter.</p>\n<p dir="ltr">Delivery Schedule</p>\n<p dir="ltr">The solar project shall be completed within 4 to 6 Working Weeks from the date of work order</p>\n<p><strong id="docs-internal-guid-beb373ea-7fff-6093-ee9f-7f205e656e5a"><br><br></strong></p>',
      };

      // Final API call to download the file
      const downloadResponse = await axiosInstance.post(
        "https://api-dev-v2.solruf.com/api/v2/proposal_file/customer",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 1446|nSwWOG2tlHSVaA1RVT7SHg6tQD4WQpRIMxrLGs3n`,
          },
          responseType: "blob", // Important for file download
        }
      );

      // Download the file without using any external library
      const fileBlob = new Blob([downloadResponse.data], {
        type: downloadResponse.headers["content-type"],
      });
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Solruf-${formData.name}-${formData.predicted_system_capacity_kw}kw-${formData.project_type}-Solar-proposal.pdf`; // Specify the file name
      document.body.appendChild(link);
      link.click();

      // Clean up by removing the link and revoking the object URL
      link.remove();
      window.URL.revokeObjectURL(url);

      setPageIdx(3);
      toast.success("File downloaded successfully.");
      // Set pageIdx back to 1 after 5 seconds
      setTimeout(() => {
        setPageIdx(1);
      }, 5000);
    } catch (error) {
      toast.error("Error submitting form:", error);
    }
  };

  function gtag_report_conversion(url) {
    const callback = () => {
      if (typeof url !== undefined) {
        window.location = url;
        // navigate(`/thankyou`);
      }
    };

    // Pushing the event to the dataLayer using react-gtm-module
    TagManager.dataLayer({
      dataLayer: {
        event: "conversion",
        send_to: "AW-16491038921/N_0gCNew67kZEMmRxbc9",
        sendTo: "AW-16491038921/N_0gCNew67kZEMmRxbc9",
        event_callback: callback,
        eventCallback: callback,
      },
    });

    return false;
  }

  const handleSendEnquiry = async (formData) => {
    //  setPageIdx(3);
    //  setTimeout(() => {
    //    setPageIdx(1);
    //  }, 4000);

    const data = {
      name: formData.name,
      phone: formData.phone,
      email: formData.email,
      address: formData.address,
      pincode: formData.pincode,
      remarks: formData.remarks,
      enquiry_type: service,
      timestamp: getTimeStamp(),
    };

    console.log(data);

    try {
      const { status } = await saveFormDataToGoogleSheet(
        data,
        "https://script.google.com/macros/s/AKfycbyM6nO2kzZcKMwdfSVmK-zDJeo7vS9tg5_wJGu7mvCW56XcVujrAHE66rEegUgDJwHqsw/exec"
      );

      if (status === 200) {
        //   setPageIdx(3);
        // sendWhatsappNotification(
        //   data.name,
        //   formData.phone,

        //   "blog_enquiry_forms_regard",
        //   [
        //     data.name,
        //     `your enquiry on ${service}`,
        //     "into the solar installation process",
        //     "https://www.solruf.com/blogs/solarInstallationProcess",
        //     "+91-8600694140",
        //     "sumit@solruf.com",
        //   ],
        //   {
        //     url: "https://i.ibb.co/SccD90M/enquiry-forms-regard.jpg",
        //     filename: "test",
        //   }
        // );
        // setTimeout(() => {
        //    setPageIdx(1);

        // }, 4000);
        const baseUrl =
          window.location.hostname === "localhost"
            ? "http://localhost:3000"
            : "https://www.solruf.com";

        gtag_report_conversion(`${baseUrl}/thankyou`);

        // navigate("/thankyou");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const service = searchParams.get("service");
    if (service === "solar_installation") {
      setService("solar installation");
      setPageIdx(2);
    }
  }, [location.search]);

  const handleSolarProjectCustomer = async (data) => {
    try {
      // Adjust the API URL as needed
      const response = await axiosInstance.post("api/customer-form", data);
      console.log("Response:", response.data);
      // Handle success response
    } catch (error) {
      console.error(
        "Error:",
        error.response ? error.response.data : error.message
      );
      // Handle error response
    }
  };

  const pages = [
    <Wrapper>
      <Background>
        <Box
          sx={{
            width: "156px",
            height: "156px",
            background: "#FFF2D1",
            borderRadius: "156px",
            position: "absolute",
            top: "-3px",
            left: "-70px",
            zIndex: "-1",
          }}
        />

        <LeadFormWrapper>
          {/* aba */}

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              rowGap: "1.5rem",
            }}
          >
            <Lottie
              animationData={solarHouse}
              loop={true}
              style={{ height: "14rem", transform: "scale(2.0)" }}
            />
            <PrimaryButton
              sx={{
                width: "100%",
                maxWidth: "30rem",
                py: 1.5,
                fontSize: "1rem",
                color: "#4d4d4d",
                backgroundColor: "primary.main",
                "&:hover": {
                  color: "#4d4d4d",
                  backgroundColor: "primary.main",
                },
                fontWeight: "600",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
              }}
              onClick={() => {
                setPageIdx(1);
              }}
            >
              Send us an Enquiry about our Services <ChevronRightIcon />
            </PrimaryButton>
            <Typography
              variant="h5"
              sx={{
                "@media (max-width: 600px)": {
                  fontSize: "1.2rem",
                },
              }}
              fontWeight={400}
            >
              or
            </Typography>
            <PrimaryButton
              component={HashLink}
              to="/#offer-form"
              sx={{
                width: "100%",
                maxWidth: "30rem",
                py: 1.5,
                fontSize: "1rem",
                background: "#4d4d4d",
                color: "primary.main",
                "&:hover": {
                  background: "#4d4d4d",
                  color: "primary.main",
                },
                fontWeight: "600",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
              }}
              // onClick={() => {
              //    rest.onClose();
              // }}
            >
              Book a Solar Site Visit
              <ChevronRightIcon />
            </PrimaryButton>
          </Box>
        </LeadFormWrapper>
      </Background>
    </Wrapper>,
    <Wrapper>
      <Background>
        <Box
          sx={{
            width: "156px",
            height: "156px",
            background: "#FFF2D1",
            borderRadius: "156px",
            position: "absolute",
            top: "-3px",
            left: "-70px",
            zIndex: "-1",
          }}
        />

        <LeadFormWrapper>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              rowGap: "1.5rem",
              "@media (max-width: 600px)": {
                rowGap: "0.4rem",
              },
            }}
          >
            <Typography
              variant="h4"
              sx={{
                "@media (max-width: 600px)": {
                  fontSize: "1.2rem",
                },
                mb: 2,
              }}
              fontWeight={500}
              textAlign="center"
            >
              What services are you looking for?
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-evenly",
                rowGap: "1.5rem",
                columnGap: "1.5rem",
                "@media (max-width: 600px)": {
                  rowGap: "1.5rem",
                  columnGap: "2.5rem",
                },

                flexWrap: "wrap",
              }}
            >
              <EnquiryMSItem
                component={motion.div}
                whileHover={{
                  scale: 0.9,
                }}
                sx={{
                  border: "1px solid #D8D8D8",
                  "-webkit-backdrop-filter": "blur(10px)",
                  "backdrop-filter": "blur(10px)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    zIndex: "10",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // setService("solar installation - Google Ads");
                    // setPageIdx(2);
                    // window.location.href = "/products";
                    navigate("/products");
                  }}
                />
                <img
                  src={siSvg}
                  alt=""
                  style={{
                    height: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                >
                  {/* SOLAR INSTALLATION */}
                  SOLAR PRODUCTS
                </Typography>
              </EnquiryMSItem>
              {/* <EnquiryMSItem
                component={motion.div}
                whileHover={{
                  scale: 0.9,
                }}
                sx={{
                  border: "1px solid #D8D8D8",
                  background: "transparent",
                  "-webkit-backdrop-filter": "blur(10px)",
                  "backdrop-filter": "blur(10px)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    zIndex: "10",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setService("solar maintenance - Google Ads");
                    setPageIdx(2);
                  }}
                />
                <img
                  src={smSvg}
                  alt=""
                  style={{
                    height: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                >
                  SOLAR MAINTENANCE
                </Typography>
              </EnquiryMSItem> */}
              <EnquiryMSItem
                component={motion.div}
                whileHover={{
                  scale: 0.9,
                }}
                sx={{
                  border: "1px solid #D8D8D8",
                  background: "transparent",
                  "-webkit-backdrop-filter": "blur(10px)",
                  "backdrop-filter": "blur(10px)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    zIndex: "10",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setService("solarProjectForm");
                    setPageIdx(4);
                  }}
                />
                <img
                  src={spSvg}
                  alt=""
                  style={{
                    height: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                >
                  BOOK A SOLAR PROJECT
                </Typography>
              </EnquiryMSItem>
              {/* <EnquiryMSItem
                component={motion.div}
                whileHover={{
                  scale: 0.9,
                }}
                sx={{
                  border: "1px solid #D8D8D8",
                  background: "transparent",
                  "-webkit-backdrop-filter": "blur(10px)",
                  "backdrop-filter": "blur(10px)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    zIndex: "10",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setService("solar financing - Google Ads");
                    setPageIdx(2);
                  }}
                />
                <img
                  src={spSvg}
                  alt=""
                  style={{
                    height: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                >
                  SOLAR FINANCING
                </Typography>
              </EnquiryMSItem> */}
              <EnquiryMSItem
                component={motion.div}
                whileHover={{
                  scale: 0.9,
                }}
                sx={{
                  border: "1px solid #D8D8D8",
                  background: "transparent",
                  "-webkit-backdrop-filter": "blur(10px)",
                  "backdrop-filter": "blur(10px)",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    top: "0",
                    left: "0",
                    cursor: "pointer",
                    zIndex: "10",
                  }}
                  component={Link}
                  to="/partner-epc"
                  // onClick={() => {
                  //    rest.onClose();
                  // }}
                />
                <img
                  src={otherSvg}
                  alt=""
                  style={{
                    height: "5rem",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontSize: "0.9rem",
                  }}
                  component="h2"
                >
                  Become a Channel Partner with us
                </Typography>
              </EnquiryMSItem>
            </Box>
          </Box>
        </LeadFormWrapper>
      </Background>
    </Wrapper>,
    <Wrapper>
      <Background>
        <LeadFormWrapper
          component="form"
          onSubmit={handleSubmit(handleSendEnquiry)}
        >
          <RowWrapper sx={{ paddingBottom: "2rem" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "60%",
                rowGap: "0.5rem",
                padding: "1rem",
                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Button
                  sx={{ padding: "0", color: "#4d4d4d" }}
                  onClick={() => {
                    setPageIdx(1);
                  }}
                >
                  <ChevronLeftIcon /> Go Back
                </Button>
              </Box>

              <Typography variant="h4" fontWeight={600}>
                Please tell us your enquiry.
              </Typography>
              <Typography variant="h5" fontWeight={400}>
                We will be get back to you shortly.
              </Typography>

              {/* <PrimaryButton
                     sx={{
                        maxWidth: '150px',
                     }}
                     IconEnd={LaunchIcon}
                     onClick={() => {
                      navigate('/solar-pump-form')
                     }}
                  >
                     Lead Form
                  </PrimaryButton> */}
            </Box>
            <FormWrapper>
              <SolrufTextField
                size="large"
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Your Name"
                {...register("name", {
                  required: {
                    value: true,
                    message: "Name is required.",
                  },
                })}
                error={errors.name}
                helperText={errors.name ? errors.name.message : ""}
              />
              <SolrufTextField
                size="large"
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Your Phone"
                {...register("phone", {
                  required: {
                    value: true,
                    message: "Phone Number  is required.",
                  },
                  minLength: {
                    value: 10,
                    message:
                      "Phone Number must be at least 10 characters long.",
                  },
                  maxLength: {
                    value: 13,
                    message: "Phone Number too long.",
                  },
                })}
                error={errors.phone}
                helperText={errors.phone ? errors.phone.message : ""}
              />
              <SolrufTextField
                size="large"
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Your Email"
                {...register("email", {
                  required: {
                    value: true,
                    message: "Email  is required.",
                  },
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                    message: "Invalid email address",
                  },
                })}
                error={errors.email}
                helperText={errors.email ? errors.email.message : ""}
              />
              <SolrufTextField
                size="large"
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Your Address"
                {...register("address", {
                  required: {
                    value: true,
                    message: "Address  is required.",
                  },
                })}
                error={errors.address}
                helperText={errors.address ? errors.address.message : ""}
              />
              <SolrufTextField
                size="large"
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Your Pincode"
                {...register("pincode", {
                  required: {
                    value: true,
                    message: "Pincode  is required.",
                  },
                })}
                error={errors.pincode}
                helperText={errors.pincode ? errors.pincode.message : ""}
              />
              <SolrufTextField
                size="large"
                multiline
                rows={3}
                sx={{
                  appearance: "none",
                  "& .MuiInputBase-root": {
                    borderRadius: "10px",
                    "-webkit-backdrop-filter": "blur(10px)",
                    "backdrop-filter": "blur(10px)",
                    background: "rgba(255, 255, 255,0.2)",
                  },
                }}
                label="Remarks (Optional)"
                {...register("remarks")}
                // error={errors.query}
                // helperText={errors.query ? errors.query.message : ""}
              />

              {/* <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <StyledCheckbox
                  label="Label"
                  defaultChecked
                  checked={whatsappChecked}
                  onChange={handleWhatsappChecked}
                  sx={{}}
                />
                <Typography variant="subtitle1">
                  Opt in for Solar Products Whatsapp Updates
                </Typography>
              </Box> */}
              <PrimaryButton
                type="submit"
                sx={{
                  width: "100%",
                  py: 1.5,
                  fontSize: "1rem",
                  background: "#4d4d4d",
                  color: "#FFD05B",
                  "&:hover": {
                    background: "#000000",
                  },

                  "&:disabled": {
                    background: "rgba(255, 208, 93, 0.5)",
                    color: "#4d4d4d",
                  },

                  fontWeight: "600",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  mt: "1.5rem",
                }}

                // disabled={isSubmitting}
              >
                Send Enquiry <SendIcon sx={{ marginLeft: "0.5rem" }} />
              </PrimaryButton>
            </FormWrapper>
            {/* <SendWrapper
              sx={{
                alignItems: "space-between",
              }}
            >
              <Lottie
                animationData={solarHouse}
                loop={true}
                style={{ height: "14rem", transform: "scale(2.2)" }}
              />
              <PrimaryButton
                type="submit"
                sx={{
                  width: "100%",
                  py: 1.5,
                  fontSize: "1rem",
                  background: "#4d4d4d",
                  color: "#FFD05B",
                  "&:hover": {
                    background: "#000000",
                  },

                  "&:disabled": {
                    background: "rgba(255, 208, 93, 0.5)",
                    color: "#4d4d4d",
                  },

                  fontWeight: "600",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  mt: "1.5rem",
                }}

                // disabled={isSubmitting}
              >
                Send Enquiry <SendIcon sx={{ marginLeft: "0.5rem" }} />
              </PrimaryButton>
            </SendWrapper> */}
          </RowWrapper>
          <Box
            sx={{
              display: "none",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              columnGap: "1.5rem",
              "@media (max-width: 600px)": {
                display: "flex",
              },
            }}
          >
            <PrimaryButton
              type="submit"
              sx={{
                width: "100%",

                py: 1.5,
                fontSize: "1rem",
                background: "#000000",
                color: "#FFD05B",
                "&:hover": {
                  background: "#000000",
                },
                fontWeight: "600",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Send Enquiry <SendIcon sx={{ marginLeft: "0.5rem" }} />
            </PrimaryButton>
          </Box>
        </LeadFormWrapper>
      </Background>
    </Wrapper>,

    <Wrapper>
      <Background>
        <ThanksWrapper>
          <Lottie
            animationData={sent}
            loop={true}
            style={{ height: "20rem", marginBottom: "4rem" }}
          />
          <Typography
            variant="h3"
            sx={{
              "@media (max-width: 600px)": {
                fontSize: "1.3rem",
              },
            }}
            fontWeight={600}
          >
            Thanks for submitting
          </Typography>
          <Typography
            variant="h5"
            fontWeight={400}
            sx={{
              "@media (max-width: 600px)": {
                fontSize: "1rem",
              },
            }}
          >
            You will be hearing from us soon!
          </Typography>
        </ThanksWrapper>
      </Background>
    </Wrapper>,
    <Wrapper>
      <Background>
        <LeadFormWrapper>
          <RowWrapper sx={{ paddingBottom: "2rem" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "60%",
                rowGap: "0.5rem",
                padding: "1rem",
                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }}
            >
              <Box sx={{ display: "flex" }}>
                <Button
                  sx={{ padding: "0", color: "#4d4d4d" }}
                  onClick={() => {
                    setPageIdx(1);
                  }}
                >
                  <ChevronLeftIcon /> Go Back
                </Button>
              </Box>
              <Typography variant="h4" fontWeight={600}>
                Book a Solar Project with us
              </Typography>
              <Typography variant="h5" fontWeight={400}>
                We offer Solar Installation, Maintenance & EMI Financing
              </Typography>
            </Box>
            <FormWrapper>
              <TextField
                label="Name"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={!!errors2.name}
                helperText={errors2.name}
                size="small"
              />
              <TextField
                label="Phone Number"
                fullWidth
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                error={!!errors2.phoneNumber}
                helperText={errors2.phoneNumber}
                size="small"
              />
              <TextField
                label="Email"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors2.email}
                helperText={errors2.email}
                size="small"
              />
              <TextField
                label="Pin Code"
                fullWidth
                name="pinCode"
                value={formData.pinCode}
                onChange={handleChange}
                error={!!errors2.pinCode}
                helperText={errors2.pinCode}
                size="small"
              />
              <TextField
                label="City"
                fullWidth
                name="city"
                value={formData.city}
                onChange={handleChange}
                error={!!errors2.city}
                helperText={errors2.city}
                size="small"
              />
              <TextField
                label="State"
                fullWidth
                name="state"
                value={formData.state}
                onChange={handleChange}
                error={!!errors2.state}
                helperText={errors2.state}
                size="small"
              />
              <TextField
                label="Address"
                fullWidth
                name="address"
                value={formData.address}
                onChange={handleChange}
                size="small"
              />
              <TextField
                label="System Size (kW)"
                fullWidth
                name="predicted_system_capacity_kw"
                value={formData.predicted_system_capacity_kw}
                onChange={handleChange}
                error={!!errors2.predicted_system_capacity_kw}
                helperText={errors2.predicted_system_capacity_kw}
                size="small"
              />
              <TextField
                label="Average Monthly Light Bill (Optional)"
                fullWidth
                name="light_bill_in_unit"
                value={formData.light_bill_in_unit}
                onChange={handleChange}
                size="small"
              />
              <TextField
                label="Electricity Tariff"
                fullWidth
                name="unit_cost"
                value={formData.unit_cost}
                onChange={handleChange}
                error={!!errors2.unit_cost}
                helperText={errors2.unit_cost}
                size="small"
              />
              <TextField
                label="Monthly Units After Solar"
                fullWidth
                name="monthly_units_after_solar"
                value={formData.monthly_units_after_solar}
                onChange={handleChange}
                error={!!errors2.monthly_units_after_solar}
                helperText={errors2.monthly_units_after_solar}
                size="small"
              />
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Select System Type</InputLabel>
                <Select
                  name="project_type"
                  value={formData.project_type}
                  onChange={handleChange}
                  error={!!errors2.project_type}
                  label="Select System Type"
                >
                  <MenuItem value="Ongrid DCR">Ongrid DCR</MenuItem>
                  <MenuItem value="Ongrid NON-DCR">Ongrid NON-DCR</MenuItem>
                  <MenuItem value="Offgrid">Offgrid</MenuItem>
                  <MenuItem value="Hybrid">Hybrid</MenuItem>
                  <MenuItem value="Installation + BOS">
                    Installation + BOS
                  </MenuItem>
                </Select>
              </FormControl>

              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel>Select Mounting Type</InputLabel>
                <Select
                  name="mounting_type"
                  value={formData.mounting_type}
                  onChange={handleChange}
                  error={!!errors2.project_type}
                  label="Select Mounting Type"
                >
                  <MenuItem value="Rooftop">Rooftop</MenuItem>
                  <MenuItem value="Ground Mounted">Ground Mounted</MenuItem>
                </Select>
              </FormControl>

              <TextField
                label="Remarks"
                fullWidth
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
              />

              <Typography sx={{ fontWeight: "bold" }}>
                What services are you looking for:
              </Typography>
              <FormGroup>
                {[
                  "Solar Installation",
                  "Solar Maintenance",
                  "EMI Project Financing",
                  "Site Visit",
                ].map((service) => (
                  <FormControlLabel
                    key={service}
                    control={
                      <Checkbox
                        checked={formData.services.includes(service)}
                        onChange={handleChange}
                        name="services"
                        value={service}
                      />
                    }
                    label={service}
                  />
                ))}
              </FormGroup>

              <Button
                fullWidth
                variant="contained"
                onClick={handleForm}
                sx={{
                  py: 1.5,
                  fontWeight: 600,
                  borderRadius: "10px",
                  mt: 2,
                  backgroundColor: "#4d4d4d",
                  color: "#FFD05B",
                  "&:hover": { backgroundColor: "#000000" },
                }}
              >
                Download a Tentative Solar Project Proposal{" "}
                <SendIcon sx={{ ml: 1 }} />
              </Button>
            </FormWrapper>
          </RowWrapper>
        </LeadFormWrapper>
      </Background>
    </Wrapper>,
  ];

  return (
    <Container>
      <Box
        sx={{
          mb: 10,
          mt: 5,
        }}
      >
        {pages[pageIdx]}
        <FormFeaturesWrapper sx={{ mt: 2 }}>
          {/* <OfferForm /> */}
          <Features />
        </FormFeaturesWrapper>
      </Box>
    </Container>
  );
};

export default SolarLeadForm2;
